import React, { useState } from 'react';
// material
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
// components
import { CampaignContact, Campaign } from '../../../entities/site';
import { MessageTemplate } from '../../../entities/notification';
import ActionButton from '../../../components/buttons/ActionButton';
import Templates from '../../../components/campaign/Templates';
import ActionButtons from './ActionButtons';

interface MessageHeaderProps {
  contact: CampaignContact;
  campaign: Campaign;
  hideOpen?: boolean;
  onEdit(contact: CampaignContact): void;
  onRefresh(contact: CampaignContact): void;
  onOpen(contact: CampaignContact): void;
  onSendMessage(contact: CampaignContact, message: string): void;
}

const MessageHeader: React.FC<MessageHeaderProps> = (props) => {
  const classes = useStyles();

  const [message, setMessage] = useState<string>('');
  const [showTemplates, setShowTemplates] = useState<boolean>(false);

  const sendMessage = () => {
    setMessage('');
    props.onSendMessage(props.contact, message);
  }

  const handleTemplatesClose = (template?: MessageTemplate) => {
    setShowTemplates(false);
    if (template) {
      setMessage(template.description);
    }
  }

  return (
    <div className={classes.container}>
      <div className={classes.replyHeader}>
        <div className={classes.replyHeaderLeft}>
          <div className={classes.phone}>{`To: ${props.contact.phoneNumber}`}</div>
          <div className={classes.url}>{`Url: ${props.contact.shortLink ? props.contact.shortLink : 'n/a'}`}</div>
        </div>
        <ActionButtons
          contact={props.contact}
          hideOpen={props.hideOpen}
          onRefresh={props.onRefresh}
          onEdit={props.onEdit}
          onOpen={props.onOpen}
        />
      </div>
      <textarea className={classes.textArea} value={message} onChange={(event: any) => setMessage(event.target.value)}>
        Reply to message
      </textarea>
      <div className={classes.buttonContainer}>
        <div>
          <ActionButton name="Use Template" size="sm" type="secondary" fullWidth onClick={() => setShowTemplates(true)} />
        </div>
        <div className={classes.rightContainer}>
          <div className={classes.rightButton}><ActionButton name="Clear" size="sm" type="secondary" fullWidth onClick={() => setMessage('')} /></div>
          <div className={classes.rightButton}><ActionButton name="Send" size="sm" fullWidth onClick={() => sendMessage()} /></div>
        </div>
      </div>
      <Templates
        open={showTemplates}
        campaignId={props.contact.campaignId}
        campaign={props.campaign}
        onClose={handleTemplatesClose}
      />
    </div>
  );

}

export default MessageHeader;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      marginBottom: 20
    },
    replyHeader: {
      display: "flex",
      justifyContent: "space-between",
      [theme.breakpoints.down('sm')]: {
        display: 'block'
      }
    },
    replyHeaderLeft: {
      display: "flex",
      [theme.breakpoints.down('sm')]: {
        display: 'block'
      }
    },
    textArea: {
      width: '100%',
      height: 125,
      [theme.breakpoints.down('sm')]: {
        height: 100
      }
    },
    buttonContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: 20
    },
    rightContainer: {
      display: 'flex'
    },
    rightButton: {
      marginLeft: 10,
      width: 100
    },
    phone: {
      padding: 7,
      textAlign: 'left',
      backgroundColor: '#f4f7fc',
      color: '#647994',
      display: 'inline-block',
      marginBottom: 5,
      [theme.breakpoints.down('sm')]: {
        width: '100%'
      }
    },
    url: {
      padding: 7,
      textAlign: 'left',
      backgroundColor: '#f4f7fc',
      color: '#647994',
      display: 'inline-block',
      marginBottom: 5,
      marginLeft: 5,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        marginLeft: 0
      }
    }
  })
);


// WEBPACK FOOTER //
// ./src/pages/campaign/components/MessageHeader.tsx